const BRAND_SERIES_COLORS = ['#1CA388', '#442B8C', '#FDB462', '#FD6B62', '#2E86DE'];

// Ângulo dourado: distribui o matiz (hue) de forma que cada nova cor fique
// visualmente distante das anteriores, mesmo com um número grande de séries
// (ao contrário de uma lista fixa, nunca repete uma cor já usada).
const GOLDEN_ANGLE = 137.508;

function seriesColor(index) {
  if (index < BRAND_SERIES_COLORS.length) {
    return BRAND_SERIES_COLORS[index];
  }
  const hue = (index * GOLDEN_ANGLE) % 360;
  return `hsl(${hue.toFixed(1)}, 65%, 45%)`;
}

const pointKey = point => (point.question_book_id !== undefined ? point.question_book_id : point.question_book);

// Alinha N séries (uma por curso/instituição) num eixo X comum de simulados, preenchendo
// com `null` os pontos que aquela série não tem (o EvolutionChart usa connectNulls).
export function buildEvolutionChartData(chartData = [], { labelKey }) {
  const books = [];

  chartData.forEach(entry => {
    (entry.points || []).forEach(point => {
      const key = pointKey(point);
      if (!books.some(book => book.key === key)) {
        books.push({ key, name: point.question_book ?? key });
      }
    });
  });

  const categories = books.map(book => book.name);

  const series = chartData.map((entry, index) => ({
    key: `${labelKey}-${index}`,
    label: entry[labelKey],
    color: seriesColor(index),
    data: books.map(book => {
      const point = (entry.points || []).find(p => pointKey(p) === book.key);
      return point ? point.score_percentage : null;
    })
  }));

  return { categories, series };
}
